var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftNavDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6871 22.5171L4.98711 14.8171C4.87044 14.7005 4.78761 14.5741 4.73861 14.438C4.68961 14.3019 4.6655 14.156 4.66628 14.0005C4.66628 13.8449 4.69078 13.6991 4.73978 13.563C4.78878 13.4269 4.87122 13.3005 4.98711 13.1838L12.6871 5.48381C12.901 5.26992 13.1686 5.15831 13.4898 5.14898C13.811 5.13964 14.0879 5.25126 14.3204 5.48381C14.5538 5.6977 14.6755 5.96526 14.6856 6.28648C14.6957 6.6077 14.5837 6.88459 14.3496 7.11714L8.63294 12.8338H21.6704C22.001 12.8338 22.2783 12.9458 22.5023 13.1698C22.7263 13.3938 22.8379 13.6707 22.8371 14.0005C22.8371 14.331 22.7255 14.6083 22.5023 14.8323C22.2791 15.0563 22.0018 15.1679 21.6704 15.1671H8.63294L14.3496 20.8838C14.5635 21.0977 14.6755 21.3699 14.6856 21.7005C14.6957 22.031 14.5837 22.3033 14.3496 22.5171C14.1357 22.7505 13.8635 22.8671 13.5329 22.8671C13.2024 22.8671 12.9204 22.7505 12.6871 22.5171Z",
    fill: "#54595F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftNavDark);
export default __webpack_public_path__ + "static/media/left-nav-dark.5c1e24ecf6d1baacb4f11a1165cfde68.svg";
export { ForwardRef as ReactComponent };